<template>
  <div v-if="descTemplate" class="instype-result-wrap">
    <contrast-liability
      :temp="descTemplate"
      :data="descData"
      :profit-btn="propProfit"
      @disShow="_fetchDisData"
    />
  </div>
</template>

<script>
import ToggleTemp from 'components/toggleTemp/toggleTemp'
import ContrastLiability from 'components/liability/contrastLiability'

export default {
  name: 'InsResultContrast',
  components: {
    ToggleTemp,
    ContrastLiability,
  },
  props: {
    template: {
      type: Object,
      default: null,
    },
    propProfit: {
      type: Array,
    },
  },
  data() {
    return {
      descTemplate: '',
      descData: '',
      disData: [],
      disActive: 0,
      disVisible: false,
      disHeader: '病种详情',
      disLink: '',
    }
  },
  watch: {
    template(newTemplate) {
      this.pageInit(newTemplate)
    },
  },
  created() {
    this.pageInit()
  },
  methods: {
    // 初始化
    pageInit(temp = this.template) {
      if (!temp) return
      this.descTemplate = {
        planLib: temp.libData,
        name: temp.name,
        insuranceTypeId: temp.insuranceTypeId,
        accountMap: temp.accountMap,
        insuredAge: temp.insuredAge,
        productNameListData: temp.productNameListData,
      }
      this.descData = temp.calData
    },
    _fetchDisData(path) {
      const { pidx, idx } = path

      const liabilities =
        this.descTemplate.liabilities[pidx].insuranceLiabilities[idx]
          .liabilities
      const diseaseAry = []
      liabilities.forEach((liab) => {
        const { title, link, detail } = liab.disease
        title &&
          diseaseAry.push({
            title,
            link,
            detail,
          })
      })

      this.disData = this._normalizeDisText(diseaseAry)
      this.disVisible = true
    },
    _closeDisDialog() {
      this.disVisible = false
    },
    _normalizeDisText(list) {
      let ret = []
      list.forEach((dis, index) => {
        let detail = dis.detail
        detail = `${detail.replace(
          /\d+[\、|\.]/g,
          '</p><p><span>$&</span>'
        )}</p>`
        detail = detail.replace(/<\/p>/, '')
        ret.push({
          fType: dis.fType,
          detail: detail,
          title: dis.title,
        })
      })
      return ret
    },
  },
}
</script>
